import type { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Brands } from "@App/Pages/Common/Brands";
import { Generations } from "@App/Pages/Common/Generations";
import { Motorizations } from "@App/Pages/Common/Motorizations";
import { Location } from "@App/Pages/Common/Location";
import { KeyNumber } from "@App/Pages/Common/KeyNumber";
import { BrakeScope } from "@App/Pages/BrakesService/BrakeScope";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the brake service.
 *
 * @constructor
 */
export const BrakesService: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("bremsenwechsel");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Bremsenwechsel"}
            step={1}
            maxSteps={6}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`modell`)}
          />
        }
      />
      <Route
        path={"/modell"}
        element={
          <Generations
            headline={"Bremsenwechsel"}
            step={2}
            maxSteps={6}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../motorisierung`, true)}
          />
        }
      />
      <Route
        path={"/motorisierung"}
        element={
          <Motorizations
            headline={"Bremsenwechsel"}
            step={3}
            maxSteps={6}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../umfang`, true)}
          />
        }
      />
      <Route
        path={"/hsn-tsn"}
        element={
          <KeyNumber
            headline={"Bremsenwechsel"}
            step={3}
            maxSteps={6}
            onVehicletreeLinkClick={() => navigateWithQuery("./")}
            onSubmit={() => navigateWithQuery(`../umfang`, true)}
          />
        }
      />
      <Route
        path={"/umfang"}
        element={
          <BrakeScope
            headline={"Bremsenwechsel"}
            step={4}
            maxSteps={6}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Bremsenwechsel"}
            step={5}
            maxSteps={6}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
      {/* Redirect old links to funnel beginning */}
      <Route path={"/modellauswahl/*"} element={<Navigate to={"/bremsenwechsel"} />} />
    </Routes>
  );
};
